import React from 'react';
import { useTranslation } from 'next-i18next';
import { PDFBox } from '@components/investors/investor-pdf-box';
import { IGetInvestorsLinksResponse } from '@anghami/neogateway/dist/endpoints/getInvestorsLinks';
import styles from './corporate-governance-section.module.scss';
import { combineCN } from '@helpers/styles.helper';
import mainStyles from '../../../pages/investors/investors.module.scss';

interface IProps {
	pdfLinks: IGetInvestorsLinksResponse['links'];
}

export default function CorporateGovernanceSection({ pdfLinks }: IProps) {
	const { t } = useTranslation();

	const committeeCharters = pdfLinks?.filter((link) => link.section === 'Committee Charters');
	const ethicsAndGuidelines = pdfLinks?.filter(
		(link) => link.section === 'Code of Ethics and Guidelines'
	);
	const proxyStatementsLinks = pdfLinks?.filter(
		(link) => link.section === 'Proxy Statement and Notice of Meeting'
	);

	return (
		<div
			id="investors-governance"
			className={combineCN(
				styles.main_wrapper,
				mainStyles.main_section_wrapper,
				'd-flex f-column f-center'
			)}
		>
			<h2 className={mainStyles.title}>{t('investor_relation_corporate_governance')}</h2>
			<div className={combineCN(styles.content_wrapper, 'd-flex f-justify-center')}>
				{committeeCharters?.length > 0 && (
					<PDFBox title={t('IR_landing_committee_charters')} data={committeeCharters} />
				)}
				{ethicsAndGuidelines?.length > 0 && (
					<PDFBox title={t('IR_landing_code_of_ethics')} data={ethicsAndGuidelines} />
				)}
				{proxyStatementsLinks?.length > 0 && (
					<PDFBox title={t('IR_landing_proxy_statements')} data={proxyStatementsLinks} />
				)}
			</div>
		</div>
	);
}
